import React from 'react'

export default function CallToActionButtons() {
    return (
        <div>
            <div className="grid grid-cols-2 mx-3">
                <div className="p-2 md:text-lg font-semibold text-center">
                    <div className="p-3 rounded w-full bg-white text-purple-700 border-2 border-purple-700 cursor-pointer">
                        <p className="text-center uppercase tracking-wide">Get on road <br className="md:hidden" />price</p>
                    </div>
                </div>
                <div className="p-2 md:text-lg font-semibold text-center">
                    <div className="p-3 rounded w-full bg-purple-700 text-white border-2 border-purple-700 cursor-pointer">
                        {/* <svg className="fill-current w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd"></path></svg> */}
                        <p className="text-center uppercase tracking-wide">Apply for <br className="md:hidden" />loan</p>
                    </div>
                </div>
            </div>
            {/* <div className="mx-3 p-2 md:text-lg font-semibold text-center">
                <div className="p-3 rounded w-full bg-white text-purple-700 border-dashed  border-2 border-purple-700 cursor-pointer">
                    <p className="text-center uppercase tracking-wide">CTA button</p>
                </div>
            </div> */}
        </div>
    )
}
